import { render, staticRenderFns } from "./AdminEditor.vue?vue&type=template&id=58538f46&"
import script from "./AdminEditor.vue?vue&type=script&lang=ts&"
export * from "./AdminEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports